import { withInstall } from '@hd-front-end/utils'
import InputNumber from './src/input-number.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElInputNumber: SFCWithInstall<typeof InputNumber> =
  withInstall(InputNumber)

export default ElInputNumber
export * from './src/input-number'
